export class DichiarazioneDTO {
	isChecked: boolean;
	dichiarazione: string;
}